import { ValueFunction } from '../../index';


function methodSum({args = []}) {
  if (args.some(v => v !== null)) {
    return args.reduce((a,b) => a+b, 0);
  } else {
    return null;
  }
}

export const sum = new ValueFunction(
  methodSum,
  {
    label: 'Sum n-Series',
    description: 'args0 + args1 + ... + argsN',
    parameters: [
      {'name': 'args', 'type': 'array:number'}
    ],
    maxLength: Infinity
  }
);